<div class="wrapper">
    <button mat-icon-button class="dialog-cancel-btn" (click)="close(false)">
        <mat-icon>close</mat-icon>
    </button>
    <h2 *ngIf="data.title">{{ data.title }}</h2>
    <p *ngIf="data.message">{{ data.message }}</p>
    <div class="actions">
        <button mat-flat-button class="dialog-confirm-btn" (click)="close(true)">
            Confirmar
        </button>
    </div>
</div>